export const navLinks = [
  { id: 'overview', label: '速览' },
  { id: 'compare', label: '新旧对比' },
  { id: 'actress', label: '女主角' },
  { id: 'bts', label: '幕后花絮' },
  { id: 'scenes', label: '经典片段' },
  { id: 'reviews', label: '影评口碑' },
  { id: 'boxoffice', label: '当年票房' },
  { id: 'faq', label: '影迷讨论' },
];

export const quickFacts = [
  { label: '原版上映', value: '1993 年', note: '香港经典情色片，由李丽珍主演' },
  { label: '3D 版上映', value: '2011 年', note: '正值 3D 情色片热潮档期' },
  { label: '共同分级', value: 'III 级', note: '两代作品均属香港三级片范畴' },
  { label: '原版符号', value: '李丽珍', note: '清纯与性感并存的银幕灵气' },
  { label: '3D 版女主', value: '吴晴晴', note: '内地新人，饰来自 2046 的未来少女' },
  { label: '3D 版噱头', value: '3D 立体 + 日援', note: '吉泽明步、加藤鹰客串制造话题' },
];

export const originalParagraphs = [
  '1993 年上映的《蜜桃成熟时》是 90 年代香港都市情色片的代表作之一。它并不靠猎奇取胜，而是把青春、夏日与都市男女的情感流动放在同一个镜头里，用轻松又不乏大胆的叙事，记录下一段属于那个年代的银幕记忆。',
  '让这部作品被反复提起的核心，是女主角李丽珍的表现。她身上那种清纯与性感并存的气质，恰好踩中了当时观众对“蜜桃”这一意象的想象，也让角色成为一个难以被简单复制的流行符号。',
  '正因如此，从影碟时代一路走到网络时代，讨论“蜜桃成熟时”的人始终绕不开原版。它更像是一块基准线：后来者无论怎样改编，都难免被拿来和它做对照。',
];

export const remakeParagraphs = [
  '2011 年，借着同年《3D 肉蒲团之极乐宝鉴》带起的 3D 情色片热潮，片方以经典 IP 为名推出了 3D 版本（正式片名常写作《蜜桃成熟时 33D》）。它把故事彻底改写：来自 2046 年的未来少女“未来”，因人类在外星辐射下丧失生育能力，不得不穿越回 2011 年寻找“完美的精子”，途中与纯情男主角相遇。',
  '为了制造话题，影片邀请日本演员吉泽明步、加藤鹰客串加盟，并把科幻穿越、对抗外星种族、打怪等元素统统塞进剧本，试图用“3D + 话题外援”两条线拉高关注度。',
  '然而从成片来看，这种拼贴式的改编也成了它后来被反复批评的原因：科技噱头有了，原版那种在都市日常里慢慢发酵的情感，反而被稀释了。',
];

export const compareTabs = [
  {
    id: 'visual',
    label: '视觉与技术',
    original: '2D 胶片拍摄，画面主打生活化的写实质感，90 年代港片的暖色调与颗粒感本身就是一种记忆滤镜。',
    remake: '以 3D 立体效果为核心卖点，大量特效与展示性镜头，数字拍摄让画面更“新”，却也更容易显得刻意。',
    diff: '一个靠氛围与胶片质感留白，一个靠立体技术制造冲击。看原版是回味，看 3D 版更像在验证当年那套技术噱头。',
  },
  {
    id: 'story',
    label: '叙事与剧情',
    original: '都市爱情与青春成长的轻喜剧，情节走得自然，人物关系是推动力。',
    remake: '科幻穿越框架：未来少女回到 2011 年寻找“完美精子”，还揉进外星种族、打怪等无厘头桥段。',
    diff: '原版讲“人”，3D 版讲“设定”。当剧情靠外星人和穿越硬撑，情感线的说服力自然就弱了一截。',
  },
  {
    id: 'cast',
    label: '演员与气质',
    original: '李丽珍的加入让角色自带话题与灵气，成为一个时代的符号。',
    remake: '以内地新人吴晴晴挑大梁，另请日本演员客串造势，整体更依赖宣传话题而非演员沉淀。',
    diff: '原版的女主是“作品成就演员，演员也成就作品”；3D 版则更像“话题先行”，这也是影迷最容易对比出来的一环。',
  },
  {
    id: 'market',
    label: '市场与口碑',
    original: '作为 90 年代经典，靠影碟与重播长线流传，口碑随岁月被不断美化。',
    remake: '借 3D 热潮取得一定商业关注，但影评普遍负面，被批评为“江河日下的情色片”，热度与同期的《3D 肉蒲团》差距明显。',
    diff: '原版是越放越香的老酒，3D 版是上得快、退得也快的时代产物。IP 能带来起点，却给不了口碑。',
  },
];

export const leadLadies = [
  {
    name: '李丽珍',
    era: '原版 1993',
    role: '“蜜桃”系列的经典符号',
    desc: '90 年代港片的代表人物之一，身上清纯与性感并存的气质，恰好贴合“蜜桃”意象。她的表演让角色超越了题材本身，成为一代观众难以复制的银幕记忆。',
  },
  {
    name: '吴晴晴',
    era: '3D 版 2011',
    role: '来自 2046 的未来少女',
    desc: '内地新人演员。据报道，其身形条件与片名中的数字被拿来呼应，因而被选中担任女主角，演绎穿越时空寻找“完美精子”的未来少女“未来”。',
  },
  {
    name: '吉泽明步',
    era: '3D 版 2011',
    role: '客串 / 话题外援',
    desc: '日本知名演员，以客串加盟的方式为影片制造宣传话题。在成片中更多承担“噱头”功能，并未真正改变影片的整体口碑走向。',
  },
  {
    name: '加藤鹰',
    era: '3D 版 2011',
    role: '特别出演',
    desc: '同样作为日本外援受邀加盟。片方希望借助其知名度拉高关注度，但受限于剧本，这类外援最终被评价为更像宣传点而非角色亮点。',
  },
];

export const btsTimeline = [
  {
    step: '01',
    title: '立项：踩中 3D 情色片热潮',
    desc: '2011 年，同类型 3D 影片《3D 肉蒲团之极乐宝鉴》大热，带动一批同类项目上马。以经典 IP 命名的 3D 改编也在这波热潮中被推向市场。',
  },
  {
    step: '02',
    title: '选角：数字与身形被拿来讨论',
    desc: '正式片名中的数字，与女主角的选角被外界联系在一起讨论。新人挑大梁，既是控制成本的选择，也自带“谁能接棒经典”的话题属性。',
  },
  {
    step: '03',
    title: '外援：日本演员客串造势',
    desc: '邀请吉泽明步、加藤鹰等日本演员加盟，是当年港产情色片常见的宣传手法。话题拉满了，但也让影片更依赖营销而非内容本身。',
  },
  {
    step: '04',
    title: '拍摄：把 3D 与特效当卖点',
    desc: '制作上主打立体效果与特效场面，试图用技术差异去回应“为什么还要再拍一次”的疑问。成片的技术展示感，也因此强过故事本身。',
  },
  {
    step: '05',
    title: '定位：用经典 IP 换情怀',
    desc: '借助“蜜桃成熟时”这个已经沉淀了十几年的名字，影片希望同时吸引老影迷与猎奇的新观众。情怀的确带来了首波关注，却没能延续成口碑。',
  },
];

export const classicScenes = [
  {
    era: '原版 1993',
    title: '夏日都市的登场氛围',
    desc: '用阳光、街道与生活化的镜头，把那个年代的夏日气息铺开。淡而不腻的起手，是很多人对原版的第一印象。',
    tag: '氛围',
  },
  {
    era: '原版 1993',
    title: '轻喜剧式的情感推进',
    desc: '人物关系在玩笑与试探里一点点拉开，情感转折不靠强设定，而靠日常互动累积出来的真实感。',
    tag: '叙事',
  },
  {
    era: '原版 1993',
    title: '女主的高光段落',
    desc: '李丽珍的戏份之所以被反复提起，是因为她把清纯与性感同时放在同一个表情里，这种张力成了系列的经典注脚。',
    tag: '表演',
  },
  {
    era: '3D 版 2011',
    title: '未来少女的穿越开场',
    desc: '以 2046 年的设定切入，交代人类在外星辐射下失去生育能力的背景，交代任务后直接穿越到 2011 年，节奏直奔设定。',
    tag: '设定',
  },
  {
    era: '3D 版 2011',
    title: '外星种族与打怪桥段',
    desc: '为对抗外星种族而展开的对抗戏份，把科幻、动作与喜剧元素硬凑在一起，是影片最被吐槽、也最像“情色版终结者”的部分。',
    tag: '特效',
  },
  {
    era: '3D 版 2011',
    title: '立体效果展示段落',
    desc: '为凸显 3D 卖点而设计的展示性镜头，在当年影院里一度是宣传点，但也常被评价为“技术盖过了故事”。',
    tag: '技术',
  },
  {
    era: '3D 版 2011',
    title: '无厘头喜剧的插科打诨',
    desc: '把恶俗与奇幻混搭的笑点贯穿其中，观影现场或许热闹，回看时却最容易让人感到拼贴与松散。',
    tag: '喜剧',
  },
];

export const reviews = [
  {
    source: '香港电影评论学会',
    verdict: '相关评论文章以《蜜桃太成熟》为题，对这次改编持批评态度，认为影片未能延续原版的气质。',
    score: 2,
  },
  {
    source: '开眼电影网（影评）',
    verdict: '一篇影评直接以“江河日下的情色电影”点题，批评其剧情拼贴、逻辑松散。',
    score: 1,
  },
  {
    source: '观众综合口碑',
    verdict: '差评居多。多数意见认为科幻、穿越、打怪与情色元素被强行揉在一起，故事缺乏说服力。',
    score: 2,
  },
  {
    source: '老影迷视角',
    verdict: '普遍怀念李丽珍那代演员的灵气，认为新人表现未能接住经典 IP 的分量，情怀落空。',
    score: 3,
  },
];

export const boxOfficePoints = [
  '2011 年前后，3D 情色片成为一股市场热潮，同类型的《3D 肉蒲团之极乐宝鉴》大热，让片方看到了“经典 IP + 3D”组合的想象空间。',
  '这部 3D 改编确实借助话题取得了初期关注，但整体票房表现被普遍评价为平平、未达爆款高度，与同期最热门的那部 3D 作品差距明显。',
  '对比原版靠影碟与重播形成的长尾影响力，3D 版更像一次“短平快”的市场尝试：热度来得快，退得也快。',
  '从结果看，经典 IP 能提供起点与情怀，却无法替代扎实的故事与表演。这也成了后来讨论港产类型片时，常被引用的一个案例。',
];

export const faqs = [
  {
    q: '蜜桃成熟时 3D 和 1993 原版是同一个故事吗？',
    a: '不是。原版是都市爱情与青春成长题材，而 3D 版把故事改写成科幻穿越：来自 2046 年的未来少女回到 2011 年寻找“完美精子”，并穿插外星种族与打怪元素。两者共享的更多是 IP 名字与“蜜桃”意象，而非剧情。',
  },
  {
    q: '3D 版的女主角到底是谁？',
    a: '据报道，3D 版由内地新人吴晴晴担任女主角，饰演来自 2046 年的未来少女“未来”；影片另邀请日本演员吉泽明步、加藤鹰客串加盟制造话题。原版《蜜桃成熟时》的女主角则是李丽珍。',
  },
  {
    q: '3D 版的立体效果值得单独去看吗？',
    a: '影片确实把 3D 与特效当作核心卖点，但在当年的评价中，技术展示常被认为“盖过了故事”。如果只为技术噱头去看，期待值不宜过高；把它当成一次时代现象来观察，反而更有意思。',
  },
  {
    q: '为什么当年的评价普遍不高？',
    a: '主要意见集中在剧情拼贴、逻辑松散，以及外援更多承担宣传功能。科幻、穿越、打怪与情色元素被强行堆叠，缺少原版那种自然推进的情感线，因而被影评人批评为“江河日下”。',
  },
  {
    q: '原版为什么能成为经典？',
    a: '原版的优势在于氛围与人物。它用生活化的叙事和 90 年代港片特有的质感，让青春与情感成为主角，加上李丽珍清纯与性感并存的表现，最终沉淀为一个难以复制的流行符号。',
  },
];

export const discussionTopics = [
  { tag: '怀旧', label: '原版滤镜', text: '“当年看原版是青春，现在看 3D 版是考古。”——老影迷对两代作品的典型感慨。' },
  { tag: '选角', label: '谁能接棒', text: '经典 IP 翻拍时，女主角的“灵气”往往比身材数字更难找，这也是讨论最集中的地方。' },
  { tag: '技术', label: '3D 值不值', text: '当立体效果成为卖点，观众到底是为技术买单，还是为故事买单？这场争论持续了十几年。' },
  { tag: '情怀', label: 'IP 的两面', text: '经典 IP 能带来首波关注，也意味着更高的期待。期待落空时，反噬往往来得更快。' },
];